<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="创建时间">
          <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="机构编号">
          <el-input v-model="searchForm.id" placeholder="请输入机构编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="关联一代编号">
          <el-input v-model="searchForm.agentId" placeholder="请输入关联一代编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <auth-button
            opt="search"
            :plain="true"
            icon="el-icon-search"
            @click.native="search"
            :loading="loading"
            label="查询"></auth-button>
          <auth-button
            opt="export"
            :plain="true"
            @click.native="exportClick"
            :loading="exportLoading"
            label="导出"></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        align="center"
        v-loading="loading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="机构编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="enterpriseTitle"
          label="机构名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="checkStatus"
          label="审核状态"
          align="center">
          <template slot-scope="scope">
            {{getStatusStr(scope.row.checkStatus)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="modifyUser"
          label="最近操作人"
          align="center">
        </el-table-column>
        <el-table-column
          prop="modifyTime"
          label="最近更新时间"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              opt="details"
              type="text"
              v-if="scope.row.status !== 0"
              @click.native="handleInfo(scope.row)"
              label="查看详情"></auth-button>
              <auth-button
              opt="edit"
              type="text"
              v-else
              @click.native="handleEdit(scope.row)"
              label="编辑"></auth-button>
              <auth-button
              opt="relate"
              type="text"
              v-if="scope.row.status === 2"
              @click.native="handleRelate(scope.row.agentId)"
              label="关联一代"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.page"></pagination>
    </el-col>
    <el-dialog
      v-if="relateDialogVisible"
      :visible.sync="relateDialogVisible"
      title="关联一代"
      width="500px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :before-close="handleClose">
      <el-form :model="relateForm" :rules="formRule" label-width="80px">
        <el-form-item prop="agentIds" label="一代编号">
          <el-input class="input" type="textarea" :autosize="{ minRows: 1, maxRows: 3}" v-model="relateForm.agentIds" placeholder='请输入一级代理商编号，并以","隔开'></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="submitRelate" :loading="submitLoading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { customerList, attachAgent, exportCustomer } from '@/api/partner'
export default {
  name: 'institutionList',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    return {
      loading: false,
      creatTime: [],
      searchForm: {
        startTime: '',
        endTime: '',
        id: '',
        agentId: ''
      },
      list: [],
      paginations: {
        page: 1,
        count: 0,
        pageSize: 20
      },
      isAgent: false,
      relateDialogVisible: false,
      submitLoading: false,
      exportLoading: false,
      relateForm: {
        id: '',
        agentIds: ''
      },
      export_form: {
        moduleCode: 7,
        moduleName: '机构',
        menuName: '机构信息'
      },
      formRule: {
        agentIds: [{
          validator: (rule, value, callback) => {
            console.log(value)
            console.log(this.relateForm.agentIds)
            if (!value) {
              callback(new Error('请输入一级代理商编号'))
            } else if (!/^(\d+,)*(\d+)$/.test(value)) {
              callback(new Error('请输入正确的代理商编号，多个代理商编号请用","隔开'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      },
      statusList: [
        { checkStatus: 'blacklist', status: -1, statusStr: '系统黑名单，禁止入网' },
        { checkStatus: 'autoCheckReject', status: 0, statusStr: '系统审核驳回' },
        { checkStatus: 'autoPassFinish', status: 2, statusStr: '自动审核完成，无需风控终审' },
        { checkStatus: 'autoPassWaitManual', status: 1, statusStr: '系统审核通过,待风控终审' },
        { checkStatus: 'autoFailWaitManual', status: 1, statusStr: '系统审核失败,待风控终审' },
        { checkStatus: 'manualCheckPass', status: 2, statusStr: '风控终审通过' },
        { checkStatus: 'manualCheckReject', status: 0, statusStr: '驳回修改' },
        { checkStatus: 'manualCheckAbort', status: -1, statusStr: '终审终止' }
      ]
    }
  },
  mounted () {
    this.getList()
    const roleId = this.$store.getters.roleId
    if (roleId === 1 || roleId === 3) {
      this.isAgent = true
    }
  },
  methods: {
    /**
         * @description 日期组件选中事件
         * @param  {String} value 当前结果
         */
    dateChange (value) {
      this.creatTime = value
    },
    /**
         * @description 点击查询
         */
    search () {
      this.paginations.page = 1
      this.getList()
    },
    exportClick () {
      this.paginations.page = 1
      this.exportCustomer()
    },
    exportCustomer () {
      this.searchForm.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchForm.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.exportLoading = true
      const params = qs.stringify(Object.assign({}, this.searchForm, this.export_form))
      exportCustomer(params).then(res => {
        this.exportLoading = false
        if (res.error_code === '0') {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 列表请求
         */
    getList () {
      this.searchForm.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchForm.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.loading = true
      const params = qs.stringify(Object.assign({}, this.searchForm, this.paginations))
      customerList(params).then(response => {
        this.loading = false
        if (parseInt(response.error_code) === 0) {
          this.paginations.count = response.total
          this.list = response.data
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 清除对象中无值属性
         */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
         * @description 改变当前页事件
         * @param  {Object} value 当前结果
         */
    onChangeCurrentPage (value) {
      this.paginations.page = value
      this.getList()
    },
    handleEdit (row) {
      console.log(this.$router)
      this.$router.push({
        path: '/Partner/Institution/institutionDetail',
        query: {
          id: row.agentId
        }
      })
    },
    handleInfo (row) {
      this.$router.push({
        path: '/Partner/Institution/institutionDetail',
        query: {
          id: row.agentId
        }
      })
    },
    handleRelate (id) {
      this.relateForm.id = id
      this.relateDialogVisible = true
    },
    handleClose () {
      this.relateForm.id = ''
      this.relateForm.agentIds = ''
      this.relateDialogVisible = false
    },
    submitRelate () {
      const params = qs.stringify(this.relateForm)
      this.submitLoading = true
      attachAgent(params).then((res) => {
        this.submitLoading = false
        console.log(res)
        if (parseInt(res.error_code) === 0) {
          this.$message({
            type: 'success',
            message: res.error_msg,
            showClose: true
          })
          this.handleClose()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: res.error_msg,
            showClose: true
          })
        }
      })
    },
    getStatusStr (checkStatus) {
      const result = this.statusList.filter(item => item.checkStatus === checkStatus)
      if (result.length) {
        return result[0].statusStr
      } else {
        return '未知'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main-view{
  padding: 0 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.input {
  // width: 80%;
  /deep/ textarea {
    resize: none;
  }
}
</style>
